import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53481f26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "quizz-qcm row" }
const _hoisted_2 = { class: "answers col-lg-6 col-12" }
const _hoisted_3 = { class: "col-lg-6 col-12" }
const _hoisted_4 = { class: "btn-submit" }
const _hoisted_5 = ["disabled"]

import QuizzQcmQuestion from '@/components/Quizz/Qcm/QuizzQcmQuestion.vue'
import Justification from '@/components/Quizz/QuizzJustification.vue'
import { QuizzJustification, QuizzSentence, QuizzType } from '@/types/Quizz'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    currentAnswersId: null,
    sentence: null,
    justification: null,
    disabledSubmitBtn: { type: Boolean },
    showJustification: { type: Boolean }
  },
  emits: ['onSubmit', 'update:currentAnswersId'],
  setup(__props: any, { emit }) {

const props = __props as {
  currentAnswersId: number[] // v-model

  sentence: QuizzSentence
  justification: QuizzJustification
  disabledSubmitBtn: boolean
  showJustification: boolean
}





const currentAnswersId = computed({
  get() {
    return props.currentAnswersId
  },
  set(value) {
    emit('update:currentAnswersId', value)
  },
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(QuizzQcmQuestion, {
          currentAnswersId: _unref(currentAnswersId),
          "onUpdate:currentAnswersId": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentAnswersId) ? (currentAnswersId).value = $event : null)),
          sentence: props.sentence,
          "show-justification": props.showJustification,
          onOnSubmitClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onSubmit')))
        }, null, 8, ["currentAnswersId", "sentence", "show-justification"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (__props.showJustification)
          ? (_openBlock(), _createBlock(Justification, {
              key: 0,
              class: "justification",
              "quizz-type": _unref(QuizzType).QCM,
              justification: props.justification
            }, null, 8, ["quizz-type", "justification"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        disabled: props.disabledSubmitBtn,
        class: "btn btn-md btn-primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('onSubmit')))
      }, _toDisplayString(props.showJustification
          ? _ctx.$t('quizz.nextQuestion')
          : _ctx.$t('quizz.submitMyChoice')), 9, _hoisted_5)
    ])
  ], 64))
}
}

})